export const TRAINING_PLANS_SECTION_ID = 'training-plans';
export const SECTION_QUERY_KEY = 'section';

export function getSectionScrollTarget(search: string): string | undefined {
  return new URLSearchParams(search).get(SECTION_QUERY_KEY) ?? undefined;
}

export function hasSectionParam(search: string): boolean {
  return new URLSearchParams(search).has(SECTION_QUERY_KEY);
}

export function stripSectionParam(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  params.delete(SECTION_QUERY_KEY);
  const qs = params.toString();
  return pathname + (qs ? `?${qs}` : '');
}

export function scrollContainerToElement(
  scrollEl: HTMLElement,
  target: HTMLElement,
  offset = 16,
) {
  const top =
    target.getBoundingClientRect().top -
    scrollEl.getBoundingClientRect().top +
    scrollEl.scrollTop;
  scrollEl.scrollTop = Math.max(0, top - offset);
}

/** Instant scroll to `?section=` target; strips the param on success. */
export function applySectionScrollFromUrl(pathname: string, search: string): boolean {
  const sectionTarget = getSectionScrollTarget(search);
  if (!sectionTarget) return false;

  const target = document.getElementById(sectionTarget);
  const scrollEl = target?.closest('section');
  if (!target || !scrollEl) return false;

  scrollContainerToElement(scrollEl as HTMLElement, target);
  window.history.replaceState(
    window.history.state,
    '',
    stripSectionParam(pathname, search),
  );
  return true;
}
